export const ASSETS = 'assets';
export const AUTHORS_AVATAR = 'assets/authors';
export const E_BOOKS_COVER = 'assets/ebooks';


